import React from "react";
import { Radio, RadioGroup, FormControl, FormControlLabel, Typography, Divider, Box } from "@material-ui/core";

import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const styled = theme => ({
  formControl: {
    margin: theme.spacing.unit,
    width: "100%"
  },
  group: {
    flexDirection: "row",
    justifyContent: "space-around"
  }
});

export default function RadioButtons(props) {

  const [selectedValue, setSelectedValue] = React.useState(0);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    props.onValueChange(event.target.value);
  };

  // return (
  //   <dev>{this.props.value}</dev>
  // );

  const question = props.value;
  const labels = props.labels;
  const value = question.value !== -1 ? question.value : null;
  var label_forms = [];
  labels.forEach((item, index) => {
    label_forms.push(<FormControlLabel
      labelPlacement="top"
      value={index}
      control={<Radio color="primary" size="small" />}
      label={<span className="radio_label">{item}</span>} />);
  });

  return (
    <ThemeProvider theme={theme}>
      <Box p={1}>
        <FormControl fullWidth>
          <Typography variant="body2">{question.text}</Typography>

          <RadioGroup className="radio" row onChange={handleChange} value={value}>
            {label_forms}
          </RadioGroup>
        </FormControl>
        <Divider></Divider>
      </Box>
    </ThemeProvider>
  )
}
